import React, { useState, useEffect } from "react";
import Logo2 from "../assets/images/navbar/hubblehox-logo.png";
import { CiLogout } from "react-icons/ci";
import { RiDashboardHorizontalFill } from "react-icons/ri";
import {
  PiExam,
  PiGraduationCap,
  PiHand,
  PiIdentificationCard,
  PiNote,
  PiNotePencilBold,
  PiQuestionBold,
  PiReceipt,
} from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import authActions from "../redux/auth/actions";
import candidatesActions from "../redux/candidates/actions";
import { Box, AppBar, Divider, Tooltip } from "@mui/material";
import Cookies from "js-cookie";
import { useNavigate, useLocation } from "react-router-dom";
import { cssProperties } from "../utils/commonCssProperties";
import { CgPlayTrackPrevR, CgProfile } from "react-icons/cg";
import reg from "../../src/assets/images/sidebar/registration.svg";
import scorecard from "../../src/assets/images/sidebar/score card.svg";
import objection from "../../src/assets/images/sidebar/objection-tracker.svg";
import reghover from "../../src/assets/images/sidebar/registration-active.svg";
import scorecardhover from "../../src/assets/images/sidebar/score card-active.svg";
import objectionhover from "../../src/assets/images/sidebar/objection-tracker-active.svg";
import { PiCreditCardLight } from "react-icons/pi";
import { MdHomeFilled } from "react-icons/md";
import { MdOutlineLogout } from "react-icons/md";
import commonReducer from "../redux/common/reducer";
import objectionTrackActions from "../redux/objectionTracker/actions";
import { CAP_REGISTRATION_URL } from "../utils/constants";


function Sidebar() {
  const [hoveredItem, setHoveredItem] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { pathname, search } = location;
  const candidateid = useSelector(
    (state) => state.authReducer.candidateTokenDetails?.candidateid
  );

  const { objectionCourses } = useSelector(
    (state) => state.objectionTrackerReducer
  );


  const paymentReceiptList = useSelector(
        (state) => state.candidatesReducer?.paymentReceiptList
      );

  const isVenueAllocationPage = pathname.includes('/venue-allocation') && 
                               search.includes('courseid=') && 
                               search.includes('coursename=');

  const handleLogout = () => {
    dispatch({ type: authActions.CANDIDATE_LOGOUT });
  };

  useEffect(() => {
    dispatch({ type: candidatesActions.GET_UPLOAD_PERSONAL_DETAILS });
  }, [])

  useEffect(() => {
        if (candidateid) {
          dispatch({
            type: "GET_PAYMENT_RECEIPT_LIST",
            payload: { candidateid: candidateid },
          });
        }
      }, [candidateid]);

    let isMenuOpen = paymentReceiptList?.some((val) => val?.statustext === 'Paid')


  useEffect(() => {
    if (candidateid) {
      dispatch({
        type: objectionTrackActions.GET_OBJECTION_COURSES,
        payload: { candidateid },
      });
    }
  }, [candidateid, dispatch]);
  
  const { personalDetails, uploadDetails, addressDetails, otherDetails } = useSelector((state) => state.candidatesReducer);
  // const { clickable} = useSelector((state) => state.commonReducer);
  const clickable = localStorage.getItem('uploaddetails')

  const allProfiledetailsDraft = 
  // personalDetails?.[0]?.candidatedraftid == null
  //   && addressDetails?.[0]?.candidateaddressdraftid == null
  //   && otherDetails?.[0]?.candidateotherdetailsdraftid == null
  //   &&
     uploadDetails?.[0]?.statusmain  ? true : false


  const handleCapRegistration = () => {
    window.location.href = `${CAP_REGISTRATION_URL}`;
  }

  const items = [
    {
      name: "Home",
      icon: <MdHomeFilled size={24} />,
      hoverIcon: <MdHomeFilled size={24} style={{ color: "#ffffff" }} />,

      path: uploadDetails.length === 0 || !allProfiledetailsDraft ? null : `/${localStorage.getItem("mhet_cnd_project")}/home`,
      disabled: uploadDetails.length === 0 || !allProfiledetailsDraft,
    },
    {
      name: "Profile",
      icon: <CgProfile size={24} />,
      hoverIcon: <CgProfile size={24} style={{ color: "#ffffff" }} />,

      path: clickable ?`/${localStorage.getItem(
        "mhet_cnd_project"
      )}/registration?page=personaldetails` : null,
      subPath: [
        `/${localStorage.getItem("mhet_cnd_project")}/registration?page=address`,
        `/${localStorage.getItem("mhet_cnd_project")}/registration?page=otherdetails`,
        `/${localStorage.getItem("mhet_cnd_project")}/registration?page=uploads`,
      ],
    },
    {
      name: "CET Registration",
      icon: <img src={reg} style={{ width: "24px", height: "24px" }} />,
      hoverIcon: <img src={reghover} style={{ width: "24px", height: "24px" }} />,
      path:  clickable ? (`/${localStorage.getItem("mhet_cnd_project")}/course-selection`) : null ,
      disabled: (uploadDetails.length === 0 || !allProfiledetailsDraft )
      // path: `/${localStorage.getItem("mhet_cnd_project")}/course-selection`,

    },
    {
      name: "CAP Registration",
      icon: <img src={reg} style={{ width: "24px", height: "24px" }} />,
      hoverIcon: <img src={reghover} style={{ width: "24px", height: "24px" }} />,
      disabled: (uploadDetails.length === 0 || !allProfiledetailsDraft ),
      path: null,
      onClick: clickable ? handleCapRegistration : null

    },
    {
      name: "Payment History",
      icon: <PiCreditCardLight size={24} />,
      hoverIcon: <PiCreditCardLight size={24} style={{ color: "#ffffff" }} />,
      path:  clickable ?  `/${localStorage.getItem("mhet_cnd_project")}/payment-receipts`:null ,
      disabled: uploadDetails.length === 0 || !allProfiledetailsDraft
    },
    {
      name: "Hall ticket or admit card",
      icon: <PiIdentificationCard size={24} />,
      hoverIcon: <PiIdentificationCard size={24} style={{ color: "#ffffff" }} />,
      path: clickable  ?  `/${localStorage.getItem("mhet_cnd_project")}/admit-card-list`: null,
      disabled: uploadDetails.length === 0 || !allProfiledetailsDraft ||   !isMenuOpen

      

    },
    {
      name: "Score card download",
      icon: <img src={scorecard} style={{ width: "24px", height: "24px" }} />,
      hoverIcon: (
        <img src={scorecardhover} style={{ width: "24px", height: "24px" }} />
      ),
      path: clickable  ?  `/${localStorage.getItem("mhet_cnd_project")}/score-card-list`: null,
      disabled: uploadDetails.length === 0 || !allProfiledetailsDraft ||  !isMenuOpen

    },
    {
      name: "Objection tracker",
      icon: <img src={objection} style={{ width: "24px", height: "24px" }} />,
      hoverIcon: (
        <img src={objectionhover} style={{ width: "24px", height: "24px" }} />
      ),
      path: clickable  ? `/${localStorage.getItem("mhet_cnd_project")}/answer-key?page=tablelist` : null,
      disabled: uploadDetails.length === 0 || !allProfiledetailsDraft ||   !isMenuOpen

    },
    {
      name: "Raise a query",
      icon: <PiQuestionBold size={24} />,
      hoverIcon: <PiQuestionBold size={24} style={{ color: "#ffffff" }} />,
      path: clickable ? `/${localStorage.getItem("mhet_cnd_project")}/query-list` : null,
      subPath: [`/${localStorage.getItem("mhet_cnd_project")}/raise-query`],
      // disabled: true,
      disabled: uploadDetails.length === 0 || !allProfiledetailsDraft

    },
    {
      name: "College selection",
      icon: <PiGraduationCap size={24} />,
      hoverIcon: <PiGraduationCap size={24} style={{ color: "#ffffff" }} />,
      disabled: true,
    },
  ];

 

  return (
    <AppBar
      position="fixed"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "97px",
        height: "100vh",
        left: 0,
        backgroundColor: "#FFFFFF",
        scrollbarWidth: "thin",
        justifyContent: "space-between",
        // padding: "24px 0px 24px 24px",
        boxShadow: "none",
        padding: "16px"
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
        onClick={() => navigate(`/${localStorage.getItem("mhet_cnd_project")}/home`)}
      >
        <img style={{ width: "80px", height: "18px" }} src={Logo2} alt="logo" />
      </Box>
      <Divider style={{ width: "100%" }} />

      <Box
        sx={{
          width:'122%',
          height: "75vh",
          overflowX: "hidden",
          overflowY: "auto",
          scrollbarWidth: "thin",
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
          "@-moz-document url-prefix()": {
            scrollbarWidth: "thin",
          },

        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "110%",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            // margin: "10px 0px",
            paddingRight: "4px",
          }}
        >
          {items.map((item, index) => {
            const isDisabled = isVenueAllocationPage ? true : item.disabled;

            const isActive =
              pathname === item.path ||
              pathname + search === item.path ||
              (Array.isArray(item.subPath) &&
                item.subPath.some((subPath) =>
                  (pathname + search).includes(subPath)
                ));

            // const handleMouseEnter = () => setHoveredItem(item.name);
            // const handleMouseLeave = () => setHoveredItem(null);

            const handleMouseEnter = () => !isDisabled && setHoveredItem(item.name);
            const handleMouseLeave = () => !isDisabled && setHoveredItem(null);



            return (
              <Tooltip
              title={ (item.name == 'CET Registration' && item.disabled ) ? "Profile to be completed before initiating the CET Application Form Registration" : item.name}
              arrow
              
            >
              
              <Box
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  
                  // cursor: item.disabled ? "not-allowed" : clickable ?  "pointer": "wait" ,
                  // cursor: item.disabled ? "not-allowed" : "pointer",

                  cursor: isDisabled ? "not-allowed" : "pointer",
                  opacity: isDisabled ? 0.5 : 1,
                  padding: "0px",
                  "& .item-icon": {
                    backgroundColor:
                      isActive || hoveredItem === item.name && !isDisabled
                        ? `${cssProperties?.hoverbgcolor?.sidebar}`
                        : "inherit",
                    borderRadius: "52px",
                    color:
                      isActive || hoveredItem === item.name && !isDisabled
                        ? "#FFFFFF"
                        : `${cssProperties?.color?.textsecondary}`,
                    color:
                      isActive || hoveredItem === item.name && !isDisabled
                        ? "#FFFFFF"
                        : `${cssProperties?.color?.textsecondary}`,
                  },
                  "& .item-name": {
                    color:
                      isActive || hoveredItem === item.name &&  !isDisabled
                        ? `${cssProperties?.color?.primary2}`
                        : `${cssProperties?.color?.textsecondary}`,
                  },
                }}
                onClick={() => (item.path ? navigate(item.path) : item.onClick ? item.onClick() : null)}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <Box
                  className={"item-icon"}
                  sx={{
                    color: "#666666",
                    width: "64px",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "38px",
                  }}
                >
                  {(hoveredItem === item.name || isActive) && !isDisabled
                      ? item.hoverIcon
                      : item.icon}
                </Box>

                {/* <Box
                  className={"item-name"}

                  sx={{
                    color: "#666666",
                    fontSize: "12px",
                    textWrap: "wrap",
                    textAlign: "center",
                    font: "Graphik",
                    cursor: item.disabled ? "not-allowed" : "pointer",
                    marginTop: "6px",
                  }}
                >
                  {item.name}
                </Box> */}
                <Box
                  className={"item-name"}
                  sx={{
                    color: "#666666",
                    fontSize: "12px",
                    textAlign: "center",
                    fontFamily: "Graphik",
                    // cursor: item.disabled ? "not-allowed" : clickable ?  "pointer": "wait" ,
                    // cursor: item.disabled ? "not-allowed" : "pointer",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    marginTop: "6px",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflow: "visible",
                    lineHeight: "1.2",
                  }}
                >
                  {item.name}
                </Box>

              </Box>
              </Tooltip>
            
            );
          })}
        </Box>
      </Box>
      <Divider style={{ width: "100%" }} />
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "#3F41D1",
          paddingRight: "12px",
        }}
      >
        <Box
          className={"item-icon"}
          sx={{ 
            cursor: "pointer" 
          }}
          onClick={() => handleLogout()}
        >
          <MdOutlineLogout
            style={{
              "&:hover": {
                backgroundColor: "#E1E8F5",
                borderRadius: "10%",
                "& .item-icon, & .item-name": {
                  color: "#0F4F96",
                },
              },
            }}
            size={24}
            color="#666666"
          />
        </Box>
        <Box
          className={"item-name"}
          sx={{
            color: "#0F4F96",
            fontSize: "12px",
            textWrap: "wrap",
            textAlign: "center",
            font: "Graphik",
            cursor: "pointer",
          }}
        >
          {"Logout"}
        </Box>
      </Box>
    </AppBar>
  );
}

export default Sidebar;
